export enum SendReportPolicy {
  None = 0,
  Daily = 1,
  Weekly = 2,
  OnCompletion = 3,
}
